import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colorTokens } from '../../app/designTokens';
import { Button } from '../ui/Button';

const { semantic } = colorTokens;

/**
 * Wizard footer. `register-submit` exists only in submit mode (step 4) so the
 * Step 1 Continue action can never be mistaken for the trial POST trigger.
 */
export function RegisterWizardFooter({
  mode = 'next',
  showBack = false,
  onBack,
  onNext,
  onSubmit,
  nextDisabled = false,
  submitDisabled = false,
  submitting = false,
}) {
  const { t } = useTranslation(['onboarding']);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      data-testid="register-wizard-footer"
      sx={{
        mt: 2.5,
        pt: 2,
        borderTop: `1px solid ${semantic.border.subtle}`,
      }}
    >
      <Box>
        {showBack ? (
          <Button
            type="button"
            variant="Ghost"
            data-testid="register-wizard-back"
            onClick={onBack}
          >
            {t('onboarding:register.wizard.back')}
          </Button>
        ) : null}
      </Box>
      <Box>
        {mode === 'submit' ? (
          <Button
            type="button"
            variant="Primary"
            data-testid="register-submit"
            loading={submitting}
            disabled={submitDisabled}
            onClick={onSubmit}
          >
            {t('onboarding:register.wizard.confirm_start')}
          </Button>
        ) : (
          <Button
            type="button"
            variant="Primary"
            data-testid="register-wizard-next"
            disabled={nextDisabled}
            onClick={onNext}
          >
            {t('onboarding:register.wizard.continue')}
          </Button>
        )}
      </Box>
    </Stack>
  );
}

export default RegisterWizardFooter;
